export default __webpack_public_path__ + "static/media/misc-books4-2048w.8991d474.png";